import { render, staticRenderFns } from "./SoreList.vue?vue&type=template&id=09ef0a89&scoped=true"
import script from "./SoreList.vue?vue&type=script&lang=js"
export * from "./SoreList.vue?vue&type=script&lang=js"
import style0 from "./SoreList.vue?vue&type=style&index=0&id=09ef0a89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef0a89",
  null
  
)

export default component.exports